
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { useConstant } from '../../utils/use-constant.mjs.js';
import { globalProjectionState } from './state.mjs.js';

var id = 1;
function useProjectionId() {
    return useConstant(function () {
        if (globalProjectionState.hasEverUpdated) {
            return id++;
        }
    });
}

export { useProjectionId };
//# sourceMappingURL=id.mjs.js.map
